module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Regular.53e1309.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Regular.woff
// module id = E7gS
// module chunks = 0